import { Icon, IconProps } from '@chakra-ui/react'

export function CompassArrowIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 53 53" fill="none" {...props}>
      <rect
        x="0.5"
        y="0.197632"
        width="52"
        height="52.6047"
        rx="26"
        fill="url(#paint0_linear_18_8100)"
      />
      <path
        d="M24.8356 28.0597L14.8911 23.9289C14.8911 23.9289 38.6475 14.2123 38.6405 14.0988C38.5146 14.1023 29.4443 37.613 29.4443 37.613C29.3848 37.6307 24.7937 28.081 24.8356 28.0597Z"
        fill="white"
      />
      <path
        d="M20.3841 28.6559L23.4857 29.6424L24.4787 32.7654L14.3594 38.9012L20.3841 28.6559Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_18_8100"
          x1="13.0236"
          y1="16.8492"
          x2="78.1602"
          y2="46.0355"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0060FF" />
          <stop offset="1" stopColor="#00FFBD" />
        </linearGradient>
      </defs>
    </Icon>
  )
}
